// extracted by mini-css-extract-plugin
export default {"link":"styles_link__-KvSx","buttonsHolder":"styles_buttonsHolder__0FTzr"};